export default function InstallPromptBanner() {
  return null;
}
